import React, { useEffect, useState } from 'react';
import { Redirect } from "react-router-dom";
import { Table, Row, Col, Pagination } from "react-bootstrap";
import DatePicker from 'react-date-picker';
import Select from 'react-select';
import { NotificationManager } from 'react-notifications';

import { CustomCard } from "../../components/Card/CustomCard";
import CustomModal from "../../components/Modal/CustomModal";

import { Consult, ChkEmail, ChkEmailF, SearchCorreos, AddMail, ChkEmailNoLeidos } from '../../funciones/EmailFunction';
import Preloader from "../../views/Preloader/Preloader";

import NewEmail from './NewEmail';
import ViewEmail from './ViewEmail';
import MailList from './MailList';

let fec = new Date();
let messContent = "";
let Uty = "";

const MainEmail = () => {
    const [correos, setCorreos] = useState([]);
    const [correosSelect, setCorreosSelect] = useState({ value: '', label: ' - Selecciona un Email - ' });
    const [correosSelect2, setCorreosSelect2] = useState({ value: '', label: ' - Selecciona un Email - ' });
    const [correosLoad, setCorreosLoad] = useState(true);
    const [mess, setMess] = useState([]);
    const [messGral, setMessGral] = useState({
        Date: "",
        Deleted: 0,
        Driver: "",
        Nmsgs: 0,
        Recent: 0,
        Size: 0,
        Unread: 0
    });
    const [preloaderMess, setPreloaderMess] = useState({ icono: "", texto: "Selecciona un Correo" });
    const [preloaderMessList, setPreloaderMessList] = useState({ icono: "", texto: "Selecciona un correo para ver los mensajes" });
    const [newEmailOpen, setNewEmailOpen] = useState(false);
    const [modalBtn1, setModalBtn1] = useState({ icono: "fa fa-plus", texto: "Agregar Email", disabled: false })
    const [flagSelect, setFlagSelect] = useState([
        { value: '/imap', label: 'imap' },
        { value: '/notls', label: 'notls' }
    ]);    
    const [flags, setFlags] = useState([
        { value: '/imap', label: 'imap' },
        { value: '/imap2', label: 'imap2' },
        { value: '/imap4', label: 'imap4' },
        { value: '/pop3', label: 'pop3' },
        { value: '/nntp', label: 'nntp' },
        { value: '/ssl', label: 'ssl' },
        { value: '/validate-cert', label: 'validate-cert' },
        { value: '/novalidate-cert', label: 'novalidate-cert' },
        { value: '/tls', label: 'tls' },
        { value: '/notls', label: 'notls' },
    ]);
    const [flagSelectSaliente, setFlagSelectSaliente] = useState([ { value: '/ssl', label: 'ssl' } ]);
    const [servidor, setServidor] = useState("mail.iudlm.com");
    const [servidorSaliente, setServidorSaliente] = useState("mail.iudlm.com");
    const [puerto, setPuerto] = useState("143");
    const [puertoSaliente, setPuertoSaliente] = useState("587");
    const [email, setEmail] = useState("");
    const [pass, setPass] = useState("");
    const [pixels, setPixels] = useState(0);
    const [infoEmail, SetInfoEmail] = useState("Selecciona una Cuenta de Correo");
    const [fecha, setFecha] = useState(fec);
    const [disDatePicker, setDisDatePicker] = useState(true);
    const [btnG1, setBtnG1] = useState({ icon: "fa fa-refresh", disabled: true });
    const [viewEmailOpen, setViewEmailOpen] = useState(false);
    const [newMailS, setNewMailS] = useState(false);
    const [messSent, setMessSent] = useState(0);
    const [messTrash, setMessTrash] = useState(0);
    const [iconNL, setIconNL] = useState({ icon: "fa fa-envelope-square", disabled: false });
    const [iconNE, setIconNE] = useState({ icon: "fa fa-paper-plane", disabled: false });
    const [iconT, setIconT] = useState({ icon: "fa fa-fa-trash", disabled: false });
    const [iconME, setIconME] = useState({ icon: "fa fa-envelope", disabled: false });
    const [paginas, setPaginas] = useState(1);
    const [pag, setPag] = useState(1);
    const [maxPagis, setMaxPagis] = useState(20);
    const [control, setControl] = useState(false);

    const styles = {
        padding: 20, fontSize: 14, cursor: "pointer"
    }

    const styles2 = {
        padding: 10, fontSize: 13, cursor: "pointer"
    }

    const styles3 = {
        padding: 10, fontSize: 11, cursor: "pointer"
    }

    const styles4 = {
        padding: 3, fontSize: 11, cursor: "pointer"
    }

    useEffect(() => {
        setCorreosLoad(false)
    }, [correos]);

    useEffect(() => {
        if (correosSelect.value !== "") verEmailFecha(correosSelect, fecha)
    }, [fecha]);

    useEffect(() => {
        Consult ((respt) => {
            Uty = respt;
            let contenido = []

            SearchCorreos ((resp) => {
                if (resp.length > 0){
                    contenido.push(resp)
                    contenido[0].push({
                        value: "add", label:<a><i className="fa fa-plus-circle" style={{color:"ee6c2b"}}></i> Agregar Nueva Cuenta</a>
                    })

                    setCorreos (contenido[0])
                }else{
                    contenido.push({
                        value: "add", label:<a><i className="fa fa-plus-circle" style={{color:"ee6c2b"}}></i> Agregar Nueva Cuenta</a>
                    })

                    setCorreos (contenido)
                }
            })
        })
    }, []);

    let cambiaFlags = (flagSelect) => {
        setFlagSelect(flagSelect)
    }

    let cambiaFlagsSaliente = (flagSelectSaliente) => {
        setFlagSelectSaliente(flagSelectSaliente)
    }

    let respOk = (data, correo) => {
        setMess([])
        setPixels (0)
        setPag(1)
        setPreloaderMess ({  icono: "", texto: "" })
        setPreloaderMessList ({  icono: "", texto: "" })
        /* setMess((data.data).reverse()); */
        const reversedMess = data.data;

        let pags = (reversedMess.length) / maxPagis;
        let pagis = 0;
        pagis = parseInt(pags)
        if (!pags % 1 == 0) pagis ++;

        setPaginas(pagis)
        setMess(reversedMess.reverse());
        setMessGral(data.info)
        setMessSent(data.sent)
        setMessTrash(data.trash)
        SetInfoEmail("Mostrar los correos del dia: ")
        setPreloaderMessList({ icono: "", texto: "No tienes correos para el dia seleccionado" })
        setCorreosSelect2(correo)
        disableButtons(false)
    }

    let viewEmail = (correo) => {
        /* setBtnG1({ icon: "fa fa-refresh", disabled: false }) */
        setPixels (2)
        setDisDatePicker(true)
        setPreloaderMess ({  icono: "fa fa-spinner fa-spin", texto: "Conectando" })
        setPreloaderMessList ({  icono: "fa fa-spinner fa-spin", texto: "Espera por favor" })
        SetInfoEmail("Mostrar los correos del dia: ")
        setCorreosSelect(correo)
        /* Primer Intento */
        ChkEmail (correo.value, fecha, (resp1) => {
            if (resp1.status === "error"){
                setPreloaderMess ({  icono: "fa fa-spinner fa-spin", texto: "Segundo intento, conectando" })
                setPreloaderMessList ({  icono: "fa fa-spinner fa-spin", texto: "Reintentando, espera por favor" })
                /* Segundo Intento */
                ChkEmail (correo.value, fecha, (resp2) => {
                    if (resp2.status === "error"){
                        setPreloaderMess ({  icono: "fa fa-spinner fa-spin", texto: "Tercer intento, conectando" })
                        setPreloaderMessList ({  icono: "fa fa-spinner fa-spin", texto: "Reintentando, espera por favor" })
                        /* Tercer Intento */
                        ChkEmail (correo.value, fecha, (resp3) => {
                            if (resp3.status === "error"){
                                /* Conexión Fallida */
                                setPreloaderMess ({  icono: "fa fa-times", texto: "Error de conexión" })
                                setPreloaderMessList ({  icono: "", texto: "Ocurrió un problema en la conexión con el servidor, intenta mas tarde" })
                                setCorreosSelect({ value: '', label: ' - Selecciona un Email - ' })
                                SetInfoEmail("Selecciona una Cuenta de Correo")
                                setPixels (0)
                                setDisDatePicker(false)
                                setBtnG1({ icon: "fa fa-refresh", disabled: true })
                                NotificationManager.error(resp3.mess);
                            }else{
                                respOk(resp3, correo)
                            }
                        })
                    }else{
                        respOk(resp2, correo)
                    }
                })
            }else{
                respOk(resp1, correo)
            }
        })
    }

    let verEmailFecha = (correo, fecha) => {
        /* setBtnG1({ icon: "fa fa-refresh", disabled: false }) */
        setPixels (2)
        setDisDatePicker(true)
        setPreloaderMess ({  icono: "fa fa-spinner fa-spin", texto: "Conectando" })
        setPreloaderMessList ({  icono: "fa fa-spinner fa-spin", texto: "Espera por favor" })
        SetInfoEmail("Mostrar los correos del dia: ")
        setCorreosSelect(correo)
        /* Primer Intento */
        ChkEmailF (correo.value, fecha, (resp1) => {
            if (resp1.status === "error"){
                setPreloaderMess ({  icono: "fa fa-spinner fa-spin", texto: "Segundo intento, conectando" })
                setPreloaderMessList ({  icono: "fa fa-spinner fa-spin", texto: "Reintentando, espera por favor" })
                /* Segundo Intento */
                ChkEmailF (correo.value, fecha, (resp2) => {
                    if (resp2.status === "error"){
                        setPreloaderMess ({  icono: "fa fa-spinner fa-spin", texto: "Tercer intento, conectando" })
                        setPreloaderMessList ({  icono: "fa fa-spinner fa-spin", texto: "Reintentando, espera por favor" })
                        /* Tercer Intento */
                        ChkEmailF (correo.value, fecha, (resp3) => {
                            if (resp3.status === "error"){
                                /* Conexión Fallida */
                                setPreloaderMess ({  icono: "fa fa-times", texto: "Error de conexión" })
                                setPreloaderMessList ({  icono: "", texto: "Ocurrió un problema en la conexión con el servidor, intenta mas tarde" })
                                setCorreosSelect({ value: '', label: ' - Selecciona un Email - ' })
                                SetInfoEmail("Selecciona una Cuenta de Correo")
                                setPixels (0)
                                setDisDatePicker(false)
                                setBtnG1({ icon: "fa fa-refresh", disabled: true })
                                NotificationManager.error(resp3.mess);
                            }else{
                                respOk(resp3, correo)
                            }
                        })
                    }else{
                        respOk(resp2, correo)
                    }
                })
            }else{
                respOk(resp1, correo)
            }
        })
    }
    
    let cambiaCorreo = (correosSelect) => {
        if (correosSelect.value === "") return null;
        if (correosSelect.value === "add") {
            setNewEmailOpen (true)
            return null;
        }

        viewEmail(correosSelect)
    }

    let disableButtons = (valor) => {
        setDisDatePicker(valor)
        setBtnG1({ icon: "fa fa-refresh", disabled: valor })
        setIconNL({ icon: "fa fa-envelope-square", disabled: valor })
        setIconNE({ icon: "fa fa-paper-plane", disabled: valor })
        setIconT({ icon: "fa fa-trash", disabled: valor })
    }

    let updEmail = () => {
        messContent = "";
        setViewEmailOpen(false)

        disableButtons(true)
        setBtnG1({ icon: "fa fa-refresh fa-spin", disabled: true })
        viewEmail(correosSelect)
    }

    let updEmail2 = () => {
        if (btnG1.disabled === true) return null
        
        setBtnG1({ icon: "fa fa-refresh fa-spin", disabled: true })
        ChkEmail (correosSelect2.value, fecha, (resp1) => {
            if (resp1.status === "error"){
                /* Segundo Intento */
                ChkEmail (correosSelect2.value, fecha, (resp2) => {
                    if (resp2.status === "error"){
                        /* Tercer Intento */
                        ChkEmail (correosSelect2.value, fecha, (resp3) => {
                            if (resp3.status === "error"){
                                /* Conexión Fallida */
                                setBtnG1({ icon: "fa fa-times", disabled: false })
                            }else{
                                respOk(resp3, correosSelect2)
                            }
                        })
                    }else{
                        respOk(resp2, correosSelect2)
                    }
                })
            }else{
                respOk(resp1, correosSelect2)
            }
        })
    }

    let respNLOk = (data) => {
        disableButtons(false)
        /* setMess(data.data); */
        const reversedMess = data.data;

        let pags = (reversedMess.length) / maxPagis;
        let pagis = 0;
        pagis = parseInt(pags)
        if (!pags % 1 == 0) pagis ++;

        setPag(1)
        setPaginas(pagis)
        setMess(reversedMess.reverse());
        setMessGral(data.info)
        setMessSent(data.sent)
        setMessTrash(data.trash)
        setCorreosSelect2(correosSelect)
        SetInfoEmail("Mostrar los correos del dia: ")
        setPreloaderMessList({ icono: "", texto: "No tienes correos para el dia seleccionado" })
    }

    let respNEOk = (data) => {
        disableButtons(false)
        /* setMess(data.data); */
        const reversedMess = data.data;
        
        let pags = (reversedMess.length) / maxPagis;
        let pagis = 0;
        pagis = parseInt(pags)
        if (!pags % 1 == 0) pagis ++;

        setPag(1)
        setPaginas(pagis)
        setMess(reversedMess.reverse());
        setMessGral(data.info)
        setMessSent(data.sent)
        setMessTrash(data.trash)
        setCorreosSelect2(correosSelect)
        SetInfoEmail("Mostrar los correos del dia: ")
        setPreloaderMessList({ icono: "", texto: "No tienes correos para el dia seleccionado" })
    }

    let respTOk = (data) => {
        disableButtons(false)
        /* setMess(data.data); */
        const reversedMess = data.data;

        let pags = (reversedMess.length) / maxPagis;
        let pagis = 0;
        pagis = parseInt(pags)
        if (!pags % 1 == 0) pagis ++;

        setPag(1)
        setPaginas(pagis)
        setMess(reversedMess.reverse());
        setMessGral(data.info)
        setMessSent(data.sent)
        setMessTrash(data.trash)
        setCorreosSelect2(correosSelect)
        SetInfoEmail("Mostrar los correos del dia: ")
        setPreloaderMessList({ icono: "", texto: "No tienes correos para el dia seleccionado" })
    }

    let verNoLeidos = () => {
        if (iconNL.disabled === true) return null
        
        messContent = "";
        setViewEmailOpen(false)

        disableButtons(true)
        setIconNL({ icon: "fa fa-spinner fa-spin", disabled: true })

        /* Primer Intento */
        ChkEmailNoLeidos (correosSelect.value, "", "UNSEEN", (resp1) => {
            if (resp1.status === "error"){
                NotificationManager.error("Reintentando, espera por favor");
                /* Segundo Intento */
                ChkEmailNoLeidos (correosSelect.value, "", "UNSEEN", (resp2) => {
                    if (resp2.status === "error"){
                        NotificationManager.error("Reintentando, espera por favor");
                        /* Tercer Intento */
                        ChkEmailNoLeidos (correosSelect.value, "", "UNSEEN", (resp3) => {
                            if (resp3.status === "error"){
                                /* Conexión Fallida */
                                NotificationManager.error(resp3.mess);
                                disableButtons(false)
                            }else{
                                respNLOk(resp2)
                            }
                        })
                    }else{
                        respNLOk(resp2)
                    }
                })
            }else{
                respNLOk(resp1)
            }
        })
    }

    let verNoEnviados = () => {
        if (iconNL.disabled === true) return null
        
        messContent = "";
        setViewEmailOpen(false)

        disableButtons(true)
        setIconNE({ icon: "fa fa-spinner fa-spin", disabled: true })

        /* Primer Intento */
        ChkEmailNoLeidos (correosSelect.value, ".Sent", "ALL", (resp1) => {
            if (resp1.status === "error"){
                NotificationManager.error("Reintentando, espera por favor");
                /* Segundo Intento */
                ChkEmailNoLeidos (correosSelect.value, ".Sent", "ALL", (resp2) => {
                    if (resp2.status === "error"){
                        NotificationManager.error("Reintentando, espera por favor");
                        /* Tercer Intento */
                        ChkEmailNoLeidos (correosSelect.value, ".Sent", "ALL", (resp3) => {
                            if (resp3.status === "error"){
                                /* Conexión Fallida */
                                NotificationManager.error(resp3.mess);
                                disableButtons(false)
                            }else{
                                respNEOk(resp2)
                            }
                        })
                    }else{
                        respNEOk(resp2)
                    }
                })
            }else{
                respNEOk(resp1)
            }
        })
    }

    let verEliminados = () => {
        if (iconNL.disabled === true) return null
        
        messContent = "";
        setViewEmailOpen(false)

        disableButtons(true)
        setIconT({ icon: "fa fa-spinner fa-spin", disabled: true })

        /* Primer Intento */
        ChkEmailNoLeidos (correosSelect.value, ".Trash", "ALL", (resp1) => {
            if (resp1.status === "error"){
                NotificationManager.error("Reintentando, espera por favor");
                /* Segundo Intento */
                ChkEmailNoLeidos (correosSelect.value, ".Trash", "ALL", (resp2) => {
                    if (resp2.status === "error"){
                        NotificationManager.error("Reintentando, espera por favor");
                        /* Tercer Intento */
                        ChkEmailNoLeidos (correosSelect.value, ".Trash", "ALL", (resp3) => {
                            if (resp3.status === "error"){
                                /* Conexión Fallida */
                                NotificationManager.error(resp3.mess);
                                disableButtons(false)
                            }else{
                                respTOk(resp2)
                            }
                        })
                    }else{
                        respTOk(resp2)
                    }
                })
            }else{
                respTOk(resp1)
            }
        })
    }

    let ContentEmail = () => {
        if (messGral.Nmsgs === 0) return (
            <div className="text-primary custom-mt-10" align="center"><i className={preloaderMess.icono}></i> {preloaderMess.texto}</div>
        )

        return (
            <React.Fragment>
                <div className="text-danger custom-mt-10" align="center"><i className={preloaderMess.icono}></i> {preloaderMess.texto}</div>
                <div className="table-responsive custom-mt-10" style={{
                    /* backgroundColor:"#FFF", */ left: 0, right: 0, position:"absolute", width: "100%", filter:`blur(${pixels}px)`
                }}>
                    <Table hover>
                        <tbody>
                            <tr onClick = {updEmail}><td align="left" width="100%" style={styles}>
                                <i className={iconME.icon} style={{color:"f8a719"}}></i> Bandeja de Entrada ({messGral.Nmsgs})
                            </td></tr>
                            <tr onClick = {verNoLeidos}><td align="left" width="100%" style={styles}>
                                <i className={iconNL.icon} style={{color:"069c63"}}></i> Mensajes No Leídos ({messGral.Unread})
                            </td></tr>
                            <tr onClick = {verNoEnviados}><td align="left" width="100%" style={styles}>
                                <i className={iconNE.icon} style={{color:"337ab7"}}></i> Mensajes Enviados ({messSent})
                            </td></tr>
                            <tr onClick = {verEliminados}><td align="left" width="100%" style={styles}>
                                <i className={iconT.icon} style={{color:"b00710"}}></i> Papelera ({messTrash})
                            </td></tr>
                            <tr><td align="left" width="100%" style={styles}>
                                <i className="fa fa-edit" style={{color:"069c63"}}></i> Respuestas Automáticas
                            </td></tr>
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        )
    }

    let mensajesList = () => {
        if (mess.length === 0) return (
            <tr>
                <td width="100%" colSpan={4} style={styles2} align="center"><i className={preloaderMessList.icono}></i> {preloaderMessList.texto}</td>
            </tr>
        )

        let contenido = [];
        let ini = 1;
        let n = 1;
        let n2 = 1;
        if (pag > 1) ini = ((pag - 1) * 20) + 1;

        for (let i in mess) {
            if (n >= ini){
                if (n2 < maxPagis) contenido.push (
                    <MailList key = {mess[i].UId} email = {correosSelect2} opciones = {mess[i]}
                    funcion = {() => {
                        if (correosSelect.value === ""){
                            NotificationManager.error("Debes Seleccionar un destinatario");
                            messContent = "";
                            setViewEmailOpen (false)
                        }else{
                            messContent = mess[i];
                            setViewEmailOpen (true)
                            updEmail2()
                        }
                    }}
                    funcion2 = {() => {
                        updEmail2()
                    }}
                    /> 
                )
                n2++;
            }

            n++;
        }

        return contenido;
    }

    let items = () => {
        let items = [];
        for (let i = 1; i <= paginas; i++) {
            items.push(
                <Pagination.Item key = {i} active={i === pag} onClick = {
                    () => {
                        setPag(i)
                        setControl(!control)
                }}>
                  {i}
                </Pagination.Item>,
              );
        }

        return items
    }

    let addEmail = () => {
        AddMail (servidor, puerto, flagSelect, servidorSaliente, puertoSaliente, flagSelectSaliente, email, pass, (resp) => {
            if (resp.tipo === "error"){
                NotificationManager.error(resp.mensaje);
                setModalBtn1({  icono: "fa fa-plus", texto: "Agregar Email", disabled: false  })
            }else{
                NotificationManager.info(resp.mensaje);
                let contenido = []
                SearchCorreos ((resp) => {
                    if (resp.length > 0){
                        contenido.push(resp)
                        contenido[0].push({
                            value: "add", label:<a><i className="fa fa-plus-circle" style={{color:"ee6c2b"}}></i> Agregar Nueva Cuenta</a>
                        })
        
                        setCorreos (contenido[0])
                    }else{
                        contenido.push({
                            value: "add", label:<a><i className="fa fa-plus-circle" style={{color:"ee6c2b"}}></i> Agregar Nueva Cuenta</a>
                        })
        
                        setCorreos (contenido)
                    }
                    
                    setModalBtn1({  icono: "fa fa-plus", texto: "Agregar Email", disabled: false  })
                    setNewEmailOpen (false)
                    setFlagSelect ([
                        { value: '/imap', label: 'imap' },
                        { value: '/notls', label: 'notls' }
                    ])
                    setServidor("")
                    setPuerto("")
                    setServidorSaliente("")
                    setPuertoSaliente("")
                    setEmail("")
                    setPass("")
                })
            }
        })
    }

    let modalEmail = () => {
        let estilo = {
            fontSize: 11
        }

        let pressAceptar = () => {
            if (modalBtn1.disabled === true) return null;
            setModalBtn1({ icono: "fa fa-spinner fa-spin", texto: "Autenticando", disabled: true })
            addEmail()
        }

        let contenidoModal = () => (
            <Row>
                <Col md={6}>
                    <div className="custom-alert-info" style={{padding: 5}}>
                        <Row>
                            <Col md={12}>
                                <div style={{backgroundColor: "4aa5a5"}} className="title-email-config">Servidor Entrante</div>
                            </Col>
                            <Col md={8}>
                                <input type="text" value={servidor} onChange={(e)=> { setServidor(e.target.value) }} className="form-control" placeholder="Ej: mail.iudlm.com"/>
                                <div style={estilo}>Ingresa el servidor entrante de correo</div>
                            </Col>
                            <Col md={4}>
                                <input type="text" value={puerto} onChange={(e)=> { setPuerto(e.target.value) }} className="form-control" placeholder="Ej: 143"/>
                                <div style={estilo}>Ingresa el puerto</div>
                            </Col>
                            <Col md={12} className="custom-mt-10">
                                <Select
                                    isMulti
                                    isSearchable ={true}
                                    /* value={flagSelect} */
                                    defaultValue = {[flags[0], flags[9]]}
                                    className="basic-multi-select"
                                    onChange={cambiaFlags}
                                    options={flags}
                                />
                                <div style={estilo}>Selecciona las banderas</div>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col md={6}>
                    <div className="custom-alert-warning" style={{padding: 5}}>
                        <Row>
                            <Col md={12}>
                                <div style={{backgroundColor: "cfab75"}} className="title-email-config">Servidor Saliente</div>
                            </Col>
                            <Col md={8}>
                                <input type="text" value={servidorSaliente} onChange={(e)=> { setServidorSaliente(e.target.value) }} className="form-control" placeholder="Ej: mail.iudlm.com"/>
                                <div style={estilo}>Ingresa el servidor saliente de correo</div>
                            </Col>
                            <Col md={4}>
                                <input type="text" value={puertoSaliente} onChange={(e)=> { setPuertoSaliente(e.target.value) }} className="form-control" placeholder="Ej: 587"/>
                                <div style={estilo}>Ingresa el puerto</div>
                            </Col>
                            <Col md={12} className="custom-mt-10">
                                <Select
                                    /* isMulti */
                                    isSearchable ={true}
                                    value={flagSelectSaliente}
                                    /* defaultValue = {[flags[5]]} */
                                    className="basic-multi-select"
                                    onChange={cambiaFlagsSaliente}
                                    options={flags}
                                />
                                <div style={estilo}>Selecciona la bandera</div>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col md={12} className="custom-mt-10" style={{borderBottom: "1px solid #e5e5e5"}}></Col>
                <Col md={6} className="custom-mt-20">
                    <input type="text" value={email} onChange={(e)=> { setEmail(e.target.value) }} className="form-control" placeholder="Ej: mail@iudlm.com"/>
                    <div style={estilo} className="text-muted">Ingresa el nombre de usuario</div>
                </Col>
                <Col md={6} className="custom-mt-20">
                    <input type="password" value={pass} onChange={(e)=> { setPass(e.target.value) }} className="form-control" placeholder="Contraseña"/>
                    <div style={estilo} className="text-muted">Ingresa la contraseña</div>
                </Col>
            </Row>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn1.icono}></i> {modalBtn1.texto}</React.Fragment>}
                large = "large"
                isopen =  {newEmailOpen}
                titulo = {<div className="text-primary" style={{fontSize: 14}}>Registrar Nueva Cuenta de Correo</div>}
                contenido = {contenidoModal()}      
                funcion1 = {pressAceptar}
                funcion2 = {() => {setNewEmailOpen(false)}}
            />
        );
    }

    let messList = () => (
        <React.Fragment>
            <div className="custom-alert-info" style={{backgroundColor:"fff", boxShadow:"2px 2px 4px #CCC"}}>
                <Row>
                    <Col md={4}>
                        <div className="btn-group" style={{paddingTop: 4}}>
                            <button className="btn btn-primary" onClick={() => {setNewMailS(!newMailS)}} style={{borderWidth: 1}} title="Redactar un Nuevo Mensaje"><i className="fa fa-pencil"></i></button>
                            <button className="btn btn-danger" disabled={btnG1.disabled} style={{borderWidth: 1}} title="Actualizar" onClick={updEmail}><i className={btnG1.icon}></i></button>
                        </div>
                    </Col>
                    <Col md={5} style={{paddingTop: 10, paddingLeft: 25}} align="right">
                        {infoEmail}
                    </Col>
                    <Col md={3} align="right">
                        <DatePicker
                            clearIcon= {false}
                            calendarIcon= {<i className="fa fa-calendar text-danger"></i>}
                            className="form-control"
                            onChange = {(date) => { if (date) setFecha(date) }}
                            value={fecha}
                            /* disabled={disDatePicker} */
                            showLeadingZeros={true}
                            dayAriaLabel = {false}
                            required = {true}
                        />
                    </Col>
                </Row>
            </div>
            <div style={{ left: 0, position:"absolute", width: "100%" }}>
                <div className="table-responsive custom-mt-10 scrollH" style={{ backgroundColor:"#fff", overflowX:"hidden", overflowY: "auto", height: "52vh" }}>
                    <Table hover>
                        <tbody>
                            <tr style={{backgroundColor: "f2f4f8", color: "fff"}}>
                                <td style={styles4}></td>
                                <td style={styles4} className="text-primary"><strong>De</strong></td>
                                <td colSpan={4} style={styles4} className="text-primary">
                                    <Row>
                                        <Col md={8} style = {{paddingTop: 12}}>
                                            <strong>Mensaje</strong>
                                        </Col>
                                        <Col md={4}>
                                            <input type="text" className="form-control" placeholder="Buscar"/>
                                        </Col>
                                    </Row>
                                </td>
                            </tr>
                            {mensajesList()}
                        </tbody>
                    </Table>
                </div>
                <div align = "center" style = {{marginTop: -15}}>
                    <Pagination bsSize = "sm">{items()}</Pagination>
                </div>
            </div>
        </React.Fragment>
    )

    let mostrarContenido = () => {
        if (newMailS === true) return (
            <NewEmail remitente={correosSelect2} funcion = {() => {setNewMailS(false)}}/>
        )

        switch (true) {
            case (messContent !== "" && viewEmailOpen === true):
                return <ViewEmail FechaC = {fecha} Content = {messContent} Email = {correosSelect2.value}
                funcion = {() => {
                    messContent = "";
                    setViewEmailOpen(false)
                }}
                funcion2 = {updEmail2}
                FullEmail = {correosSelect}/>
            case (messContent === "" && viewEmailOpen === false):
                return messList()
            default: return null
        }

    }

    let contenido = () => (
        <Row>
            <Col md={3} style={{
                overflowX:"hidden", overflowY: "auto", height: "67vh",
                borderRight: "1px solid #ccc", backgroundColor: "f2f4f8", paddingTop: 10,
                boxShadow:"1px 0px 4px #ccc", zIndex: 5
            }}>
                <Select
                    isSearchable ={true}
                    isLoading = {correosLoad}
                    value={correosSelect}
                    onChange={cambiaCorreo}
                    options={correos}
                />
                {ContentEmail()}
            </Col>
            <Col md={9}>
                {mostrarContenido()}
            </Col>
        </Row>
    )
    
    switch (Uty) {
        case "EST":
            return (<Redirect to="/noticias" />)
        case "PROF": return (
            <React.Fragment>
                <div className="content">
                    <Row>
                        <Col md={12}>
                            <div style={{borderRadius: "4px 4px"}}>
                                <CustomCard
                                    title= "Mis Correos"
                                    category=""
                                    color="#a80012"
                                    content={contenido()}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
                {modalEmail()}
            </React.Fragment>
        );
        case "WEBMASTER":
            return (<Redirect to="/noticias" />)
        case "DIR": return (
            <React.Fragment>
                <div className="content">
                    <Row>
                        <Col md={12}>
                            <div style={{borderRadius: "4px 4px"}}>
                                <CustomCard
                                    title= "Mis Correos"
                                    category=""
                                    color="#a80012"
                                    content={contenido()}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
                {modalEmail()}
            </React.Fragment>
        )
        case "ADMIN": return (
            <React.Fragment>
                <div className="content">
                    <Row>
                        <Col md={12}>
                            <div style={{borderRadius: "4px 4px"}}>
                                <CustomCard
                                    title= "Mis Correos"
                                    category=""
                                    color="#a80012"
                                    content={contenido()}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
                {modalEmail()}
            </React.Fragment>
        )
        default: return (<Preloader/>)
    }
}

export default MainEmail;


// WEBPACK FOOTER //
// ./src/views/Email/MainEmail.jsx